import Grid from '@mui/material/Grid'
import { styled } from '@mui/material/styles'

export const Image = styled('img')({
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    objectPosition: '90%',
})

export const LogoContainer = styled('div')({
    padding: '52px 36px',
})

export const Logo = styled('img')({
    width: 120,
})

export const GridLeft = styled(Grid)({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: '40px',
    background:
        'linear-gradient(-146deg, #ffffff 0.54%, rgba(255, 255, 255, 0.78) 100%)',
    maxHeight: '100vh',
    overflow: 'auto',

    '@media (max-width: 768px)': {
        gap: '20px',
    },
})

export const GridContainer = styled(Grid)({
    minHeight: '100vh',
    maxHeight: '100vh',

    overflow: 'hidden',
})

export const FormContainer = styled('div')({
    width: 280,
    margin: '0 auto',
})
